export default __webpack_public_path__ + "static/media/easyUse.7afbce64.png";